// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__XPm3l","rightAdornment":"Header_rightAdornment__1w28R"};